export default {
  BASE_URL: '/fm/invoice',
  api: [
    {
      name: 'list',
      desc: '列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '明细',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'cancel',
      desc: '作废',
      method: 'POST',
      path: '/cancel'
    },
    {
      name: 'reInvoiceList',
      desc: '关联进项发票',
      method: 'GET',
      path: '/order/getRelInvoice'
    },
    {
      name: 'reInvoiceDetail',
      desc: '关联进项发票明细',
      method: 'GET',
      path: '/order/detail/re/invoice'
    },
    {
      name: 'getBillStatusEnum',
      desc: '状态列表',
      method: 'GET',
      path: '/getBillStatusEnum'
    },
    {
      name: 'pushKinDee',
      desc: '发票推送金额',
      method: 'POST',
      path: '/push/kinDee'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/outputInvoice/management.js